import React from "react";
import { FaStar } from "react-icons/fa";
import styled from "styled-components";

const SidesBox = ({
  sideGroup,
  config,
  t,
  menuType,
  formatPrice
}) => {
  const sideConfig = config.extras?.[sideGroup];
  const isCashMenu = menuType.includes("cash");
  const isTournamentMenu = menuType.includes("tournament");
  const hideItems = isCashMenu && sideConfig?.hideItemsOnCash;

  if (isTournamentMenu && sideConfig?.hideOnTournament) return null;

  return (
    <RedBox className="item-row">
      <h6>{t(`extras.categories.${sideGroup}.title`, "Sides")}
        {/* {console.log("config extras", config.extras)} */}
        {menuType.includes("cash") && config.extras?.[sideGroup]?.starred && (
          <span className="star-icon">
            <FaStar />
          </span>
        )}
      </h6>
      {isCashMenu && (
        <p>{t(`extras.categories.${sideGroup}.cashDescription`, "")}</p>
      )}

      {/* Render side items */}
      {!hideItems && (sideGroup === "pizzaSides" ? (
        // Special handling for PIZZA sides which has nested groups
        Object.entries(t(`extras.categories.pizzaSides.groups`, { returnObjects: true }) || {}).map(([groupKey, groupData], groupIndex) => (
          <div key={groupIndex} className="side-group">
            <h6 className="side-group-title">
              {groupData.title ?? groupKey}
            </h6>
            <div className="pizza-sides side-items">
              {Object.entries(t(`extras.categories.pizzaSides.groups.${groupKey}.items`, { returnObjects: true }) || {}).map(([itemKey, itemData], itemIndex) => {
                const sideTitle = t(`extras.categories.pizzaSides.groups.${groupKey}.items.${itemKey}.title`, itemKey);
                // Get the price and starred properties from the config file
                const configItem = config.extras?.pizzaSides?.[groupKey]?.items?.[itemKey];
                const starred = configItem?.starred || false;
                const price = configItem?.price;

                return (
                  <div key={itemIndex} className="side-item">
                    <span>
                      {sideTitle}
                      {menuType.includes("tournament") && price && (
                        <span className="price ps-2">
                          {formatPrice(price)}
                        </span>
                      )}
                      {menuType.includes("cash") && starred && (
                        <span className="star-icon">
                          <FaStar />
                        </span>
                      )}
                    </span>
                  </div>
                );
              })}
            </div>
          </div>
        ))
      ) : (
        // Regular sides handling
        <div className="side-items">
          {Object.entries(t(`extras.categories.${sideGroup}.items`, { returnObjects: true }) || {}).map(([itemKey, itemData], itemIndex) => {
            const sideTitle = t(`extras.categories.${sideGroup}.items.${itemKey}.title`, itemKey);
            // Get the price and starred properties from the config file
            const configItem = config.extras?.[sideGroup]?.items?.[itemKey];
            const starred = configItem?.starred || false;
            const price = configItem?.price;
            const description = t(`extras.categories.${sideGroup}.items.${itemKey}.description`, "");

            return (
              <p key={itemIndex} className="side-item">
                <span>
                  {sideTitle}
                  {menuType.includes("tournament") && price && (
                    <span className="price">
                      {formatPrice(price)}
                    </span>
                  )}
                  {menuType.includes("cash") && starred && (
                    <span className="star-icon">
                      <FaStar />
                    </span>
                  )}
                </span>
                {description && <span className="side-description">{description}</span>}
              </p>
            );
          })}
        </div>
      ))}
    </RedBox>
  );
};

// Styled components
const RedBox = styled.div`
  position: relative;
  padding: 20px 40px !important;
  background: var(--mutedred);
  display: flex;
  flex-direction: column !important;
  align-items: center !important;
  justify-content: center !important;
  text-align: center;
  & > h6 {
    margin: 0 0 15px;
    font-size: 18px;
    text-transform: uppercase;
  }
  & > p {
    margin: 5px 0 0 0;
    font-size: 14px;
    font-weight: normal !important;
  }

  .side-group {
    margin-bottom: 15px;
    .side-group-title {
      font-size: 16px;
      margin-bottom: 10px;
      text-transform: uppercase;
    }
  }

  .side-items {
    text-align: center;
    &.pizza-sides {
      .side-item {
        &:after {
          color: var(--red);
        }
        &:last-child:after {
          content: "";
        }
      }
    }
    .side-item {
      font-size: 14px;
      color: var(--mutedwhite);
      margin-bottom: 0.3rem;
      line-height: 1.5rem;
      &:last-child {
        margin-bottom: 0;
      }
      .side-description {
        display: block;
        font-size: 12px;
        line-height: 1.25rem;
      }
    }
  }

  .star-icon {
    color: var(--mustard);
    margin-left: 5px;
    font-size: 12px;
    display: inline-block;
    position: relative;
    bottom: 2px;
  }

  .price {
    white-space: nowrap;
    &:before {
      content: " - ";
    }
  }
`;

export default SidesBox;
